import React from 'react'
import {useTranslations} from 'next-intl'
import {Paper} from '@mui/material'
import {css} from '@emotion/react'

import BasicDialog from '../elements/BasicDialog'
import Button from '../elements/Button'
import JSONView from './JSONView'


function JSONViewButton({text, ...props}) {
  const styles = {
    content: css`
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      padding: 8px;
      min-width: 300px;
      min-height: 300px;
    `,
  }

  const t = useTranslations()
  const [dialogOpen, setDialogOpen] = React.useState(false)

  const onDialogOpen = React.useCallback(() => {
    setDialogOpen(true)
  }, [])

  const onDialogClose = React.useCallback(() => {
    setDialogOpen(false)
  }, [])

  const disabled = React.useMemo(() => !isJSONShowable(text), [text])
  const jsonData = React.useMemo(() => disabled ? {} : JSON.parse(text), [disabled, text])

  return (
    <>
      <Button disabled={disabled} onClick={onDialogOpen} {...props}>{t('json-view-button.label')}</Button>

      <BasicDialog open={dialogOpen} onClose={onDialogClose} title={t('json-view-button.dialog-title')}>
        <Paper css={styles.content} elevation={1} square>
          <JSONView indentWidth={4} data={jsonData}/>
        </Paper>
      </BasicDialog>
    </>
  )
}

export const isJSONShowable = (value) => {
  try {
    const jsonData = JSON.parse(value)
    return typeof jsonData === 'object' && jsonData !== null
  } catch {
    return false
  }
}


export default React.memo(JSONViewButton)
